import { render, staticRenderFns } from "./OverlayContainer.vue?vue&type=template&id=49aaa506&scoped=true&"
import script from "./OverlayContainer.vue?vue&type=script&lang=js&"
export * from "./OverlayContainer.vue?vue&type=script&lang=js&"
import style0 from "./OverlayContainer.vue?vue&type=style&index=0&id=49aaa506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aaa506",
  null
  
)

export default component.exports